import { Reveal } from "./Reveal";
import { useLang } from "../../i18n/LanguageContext";

export const WhyWeExist = () => {
  const { t } = useLang();
  return (
    <section
      id="why-we-exist"
      data-testid="why-we-exist-section"
      className="scroll-mt-24 bg-[#1A1C19] py-24 md:py-32"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 grid lg:grid-cols-12 gap-10 lg:gap-16">
        <Reveal className="lg:col-span-4">
          <p className="text-xs md:text-sm font-medium tracking-[0.3em] uppercase text-[#B5A68B] mb-6">
            {t.why.overline}
          </p>
          <h2 className="font-serif text-3xl md:text-5xl leading-tight tracking-tight text-[#F4F3EF]">
            {t.why.title}
          </h2>
        </Reveal>

        <Reveal delay={0.15} className="lg:col-span-8">
          <div className="space-y-6 text-lg md:text-xl leading-relaxed text-[#D8D6CF]">
            <p>{t.why.p1}</p>
            <p>{t.why.p2}</p>
          </div>
        </Reveal>
      </div>
    </section>
  );
};
